module.exports = __webpack_public_path__ + "img/zip.6a6d950b.png";